module.exports = __webpack_public_path__ + "img/1549.30b93948.gif";